import React from 'react';
import DataGrid, { Column} from 'devextreme-react/data-grid';


class ScaleEditGrid extends React.Component {
  constructor(props) {
    super(props);
  }

 
  render() {
    return (
      <React.Fragment>
        <DataGrid
          id="gridContainerSkillResources"
          dataSource={this.props.resources}
          keyExpr="info.id"
          allowColumnReordering={true}
          showBorders={true}
          showColumnHeaders={false}
         >
          <Column  key="name" dataField="data.name" dataType="string" />
          <Column  key="count" dataField="data.count" alignment="center" dataType="number" width={100} />
        </DataGrid>
      </React.Fragment>
    );
  }
}

export default ScaleEditGrid;
